module.exports = __webpack_public_path__ + "img/26.dd3d2017.jpg";